import React from 'react'
import { BsFacebook, BsGithub, BsInstagram } from 'react-icons/bs'

const SocialMedia = () => {
    return (
        <>
            <a href="http://www.facebook.com/abtahinoorsm" target="_blank" rel="noopener noreferrer">
                <BsFacebook className="transition duration-300 w-6 h-6 text-indigo-700 hover:scale-110 transform" />
            </a>
            <a href="http://www.instagram.com/smabtahinoor" target="_blank" rel="noopener noreferrer">
                <BsInstagram className="transition duration-300 w-6 h-6  text-indigo-700 hover:scale-110 transform" />
            </a>
            <a href="http://www.github.com/19smabtahinoor" target="_blank" rel="noopener noreferrer">
                <BsGithub className="transition duration-300 w-6 h-6 text-indigo-700 hover:scale-110 transform" />
            </a>
        </>
    )
}

export default SocialMedia
